import { configureStore, combineReducers } from "@reduxjs/toolkit";

import addGuestReducer from "./slice/Addguest.slice";
import widgetSettingReducer from "./slice/widgetSetting.slice";
import feedbackReducer from "./slice/feedback.slice";
import webshopReducer from "./slice/Webshop.slice";
import ActivityReducer from "./slice/Activity.slice";
import TicketingReducer from "./slice/Ticketing.slice";
import CombinationReducer from "./slice/Combination.slice";
import salonReducer from "./slice/Salon.slice";

const rootReducer = combineReducers({
  addGuest: addGuestReducer,
  widgetSettings: widgetSettingReducer,
  feedback: feedbackReducer,
  Webshop: webshopReducer,
  Activity: ActivityReducer,
  Ticketing: TicketingReducer,
  Combination: CombinationReducer,
  salon: salonReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});

